import React from "react";
import UnderConstruction from "../../components/apartments/UnderConstruction/UnderConstruction";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";

import heroImage1 from "../../assets/images/great-hall/greatHall50.jpg";

export default function Apartments() {
  const { t } = useTranslation("apartments");
  return (
    <>
      {" "}
      <Helmet>
        <title>Apartmani</title>
        <meta
          name="description"
          content={"Radimo na tome da ova stranica bude spremna što pre"}
        />
        <link rel="canonical" href={"https://vidovdanrestoran.rs/apartments"} />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content={"Apartmani"} />
        <meta
          property="og:description"
          content={"Radimo na tome da ova stranica bude spremna što pre"}
        />
        <meta property="og:image" content={heroImage1} />
        <meta
          property="og:url"
          content={"https://vidovdanrestoran.rs/apartments"}
        />
        <meta property="og:site_name" content="Vidovdan" />
        <meta property="og:locale" content="sr_RS" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={"Apartmani"} />
        <meta
          name="twitter:description"
          content={"Radimo na tome da ova stranica bude spremna što pre"}
        />
        <meta name="twitter:image" content={heroImage1} />
      </Helmet>
      <UnderConstruction t={t} />
    </>
  );
}
